import { ArrowRight, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const quickLinks = [{
  label: "Refrigerated Trailers",
  to: "/RefrigeratedTrailersPage"
}, {
  label: "Rental Options & Pricing",
  to: "/RentalOptionsPricingPage"
}, {
  label: "Service Areas",
  to: "/ServiceAreasPage"
}, {
  label: "53-Foot Reefer Trailer",
  to: "/FootRefrigeratedTrailerRentalsPage"
}, {
  label: "Request a Quote",
  to: "/ContactRequestAQuotePage"
}];
export default function QuoteCta() {
  return <section id="quoterequestcta" data-nav="light" className="relative bg-background text-foreground py-20 md:py-28 border-t border-border overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl">
        <div className="text-center space-y-8">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-default font-semibold tracking-tight text-foreground max-w-3xl mx-auto leading-tight">
            Ready to secure your mobile cold storage? Request your quote today
          </h2>

          <p className="text-base sm:text-lg text-muted-foreground max-w-3xl mx-auto leading-relaxed">
            Request quote-based pricing for your dates, delivery location, intended use, temperature requirements, preferred trailer size, site-access details, and available power.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-2">
            <Button asChild size="lg" className="w-full sm:w-auto text-base px-8 h-12 shadow-sm">
              <Link to="/ContactRequestAQuotePage">
                Request a Quote
                <ArrowRight className="size-4 ml-1" />
              </Link>
            </Button>

            <Button asChild variant="outline" size="lg" className="w-full sm:w-auto text-base px-7 h-12 border-border">
              <a href="tel:2135218821">
                <Phone className="size-4 mr-1 text-primary" />
                Call 213-521-8821
              </a>
            </Button>
          </div>

          <div className="pt-10 border-t border-border/80 mt-12">
            <nav aria-label="Quick links" className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3">
              {quickLinks.map((link, i) => <Link key={link.to + i} to={link.to} className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors underline-offset-4 hover:underline">
                  {link.label}
                </Link>)}
            </nav>
          </div>
        </div>
      </div>
    </section>;
}